import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFacilityCarePath} from './PropertyPaths/accidentFacilityCarePath';

export const DailyHospitalConfinement = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentFacilityCarePath(selectedPlan?.planIndex || 0, 0);

  const productCd = selectedProduct?.code ?? '';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'daily-hospital-row-1'},
      items: [
        {
          key: propertyPaths.hospitalConfinementDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.hospitalConfinementDetails.incurralPeriod)}
              id={propertyPaths.hospitalConfinementDetails.incurralPeriod}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.hospitalConfinementDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.hospitalConfinementDetails.customizeBenefitAmount)}
              disabled
              id={propertyPaths.hospitalConfinementDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'daily-hospital-row-2'},
      items: [
        {
          key: propertyPaths.hospitalConfinementDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount (Per Day)"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.hospitalConfinementDetails.benefitAmount)
              )}
              id={propertyPaths.hospitalConfinementDetails.benefitAmount}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.hospitalConfinementDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Number of Days per Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.hospitalConfinementDetails.maxBenefitNumber)}
              id={propertyPaths.hospitalConfinementDetails.maxBenefitNumber}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'daily-hospital-row-3'},
      items: [
        {
          key: propertyPaths.hospitalConfinementDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`${productCd}HospitalConfinementBenefit.timePeriodCd`}
              label="Time Period"
              disabled
              value={getQuoteFieldValue<number>(propertyPaths.hospitalConfinementDetails.timePeriodCd)}
              id={propertyPaths.hospitalConfinementDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
